var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_603_5691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0683 15C13.8199 15 13.6025 14.9068 13.4161 14.7205L5.2795 6.58385C4.90683 6.21118 4.90683 5.62112 5.2795 5.2795C5.65217 4.90683 6.24224 4.90683 6.58385 5.2795L14.7205 13.3851C15.0932 13.7578 15.0932 14.3478 14.7205 14.6894C14.5342 14.9068 14.2857 15 14.0683 15Z",
    fill: "#9FA1A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93168 15C5.68323 15 5.46584 14.9068 5.2795 14.7205C4.90683 14.3478 4.90683 13.7578 5.2795 13.4161L13.3851 5.2795C13.7578 4.90683 14.3478 4.90683 14.6894 5.2795C15.0621 5.65217 15.0621 6.24224 14.6894 6.58385L6.58385 14.7205C6.39752 14.9068 6.18012 15 5.93168 15Z",
    fill: "#9FA1A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_603_5691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.12ad99009e7898f3680cb9065078d5f7.svg";
export { ForwardRef as ReactComponent };